import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { Component } from 'react';
import { PropTypes } from 'prop-types';
import { ZendeskCategories, ZendeskSubCategories } from './ZendeskCategories';
import { connect } from '../../node_modules/react-redux';
import Utils from '../../utils';
import DeviceInfo from '../../api/DeviceInfo';
import FormId from '../../components/Form/FormId';
import CustomerSupportInterface from '../../api/CustomerSupportInterface';
import { ZendeskFieldIds } from './Constants';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { getText, TEXT_KEY } from '../../utils/localization';

var CustomerSupport = /*#__PURE__*/function (_Component) {
  function CustomerSupport(props) {
    var _this2;

    _classCallCheck(this, CustomerSupport);

    _this2 = _callSuper2(this, CustomerSupport, [props]);

    _this2.initForm = function () {
      var _this2$props = _this2.props,
          setFormInfo = _this2$props.setFormInfo,
          CustomerSupportForm = _this2$props.CustomerSupportForm;
      var category = ZendeskCategories[0].value;
      CustomerSupportForm.steps[0].formInputList[0].options = ZendeskCategories;
      CustomerSupportForm.steps[0].formInputList[1].options = ZendeskSubCategories[category];

      _this2.setState({
        layout: _this2.checkCustomerSupportForm(CustomerSupportForm)
      });

      setFormInfo({
        key: FormId.CATEGORY,
        value: category,
        validated: true
      });
      setFormInfo({
        key: FormId.SUBCATEGORY,
        value: ZendeskSubCategories[category][0].value,
        validated: true
      });
    };

    _this2._submitSupportMessage = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(handleResponse) {
        var _this2$props2, formInfo, playerId, casinoId, playerName, email, messageBody, platform, bodyParams, response, eventPayload, _eventPayload;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2$props2 = _this2.props, formInfo = _this2$props2.formInfo, playerId = _this2$props2.playerId, casinoId = _this2$props2.casinoId, playerName = _this2$props2.playerName, email = _this2$props2.email;

                if (!(!formInfo.subcategory.validated && !formInfo.subject.validated && !formInfo.body.validated)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                messageBody = "".concat(formInfo.body.value, "\n\n").concat(getText(TEXT_KEY.PLAYER_ID), ": ").concat(playerId);
                messageBody += "\n".concat(getText(TEXT_KEY.MEMBER_ID), ": ").concat(casinoId);
                messageBody += "\n".concat(getText(TEXT_KEY.USER_AGENT), ": ").concat(Utils.getUA());

                if (Utils.isReactNative()) {
                  messageBody += "\n".concat(getText(TEXT_KEY.DEVICE), ": ").concat(DeviceInfo.getDevice());
                  messageBody += "\n".concat(getText(TEXT_KEY.SYSTEM_VERSION), ": ").concat(DeviceInfo.getSysVer());
                  messageBody += "\n".concat(getText(TEXT_KEY.APP_VERSION), ": ").concat(DeviceInfo.getBundleVer(), " (").concat(DeviceInfo.getBundleId(), ")");
                }

                platform = Utils.getPlatform();
                bodyParams = {
                  request: {
                    requester: {
                      name: playerName,
                      email: email
                    },
                    priority: 'normal',
                    subject: formInfo.subject.value,
                    comment: {
                      body: messageBody
                    },
                    custom_fields: [{
                      id: ZendeskFieldIds.PLATFORM,
                      value: "platform_".concat(platform === 'web' ? 'desktop' : platform)
                    }, {
                      id: ZendeskFieldIds.CATEGORY,
                      value: formInfo.subcategory.value
                    }]
                  }
                };
                _context.prev = 9;
                _context.next = 12;
                return CustomerSupportInterface.sendSupportMessage(bodyParams);

              case 12:
                response = _context.sent;

                if (response) {
                  eventPayload = {
                    subject: formInfo.subject.value,
                    body: formInfo.body.value
                  };
                  Logger.sendEvent(EVENT_TYPES.USER_CONTACTED_SUPPORT, eventPayload);
                  !!handleResponse && handleResponse(true);

                  _this2.setState({
                    responseSuccess: true,
                    messageResponse: "".concat(getText(TEXT_KEY.MESSAGE_SUCCESSFULLY_SENT), " ").concat(getText(TEXT_KEY.BACK_TO_YOU_SHORTLY))
                  });
                } else {
                  !!handleResponse && handleResponse(false);

                  _this2.setState({
                    responseSuccess: false,
                    messageResponse: "".concat(getText(TEXT_KEY.SOMETHING_WENT_WRONG), " ").concat(getText(TEXT_KEY.TRY_AGAIN_OR_CONTACT_SUPPORT))
                  });

                  _eventPayload = {
                    description: "".concat(getText(TEXT_KEY.CONTACT_SUPPORT_FAILED), ", ").concat(getText(TEXT_KEY.SOMETHING_WENT_WRONG), " ").concat(getText(TEXT_KEY.TRY_AGAIN_OR_CONTACT_SUPPORT)),
                    code: 23
                  };
                  Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, _eventPayload);
                }

                _context.next = 21;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](9);
                !!handleResponse && handleResponse(false);
                console.log('Zendesk Error: ', _context.t0);

                _this2.setState({
                  responseSuccess: false,
                  messageResponse: "".concat(getText(TEXT_KEY.SOMETHING_WENT_WRONG), " ").concat(getText(TEXT_KEY.TRY_AGAIN_OR_CONTACT_SUPPORT))
                });

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[9, 16]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this2.checkCustomerSupportForm = function (CustomerSupportForm) {
      if (CustomerSupportForm) {
        var step = CustomerSupportForm.steps[0];

        if (step) {
          var formInputList = step.formInputList;

          if (formInputList && formInputList.length > 0) {
            if (formInputList[0].label) {
              formInputList[0].label = getText(TEXT_KEY.CUSTOMER_SUPPORT_FORM_TITLE);
            }

            if (formInputList[1] && formInputList[1].placeholder) {
              formInputList[1].placeholder = getText(TEXT_KEY.CUSTOMER_SUPPORT_FORM_BODY);
            }
          }

          if (step.submitButtonText) {
            step.submitButtonText = getText(TEXT_KEY.CUSTOMER_SUPPORT_FORM_SEND);
          }
        }
      }

      return CustomerSupportForm;
    };

    _this2.state = {
      layout: _this2.props.CustomerSupportForm,
      messageResponse: '',
      responseSuccess: null
    };
    return _this2;
  }

  _inherits(CustomerSupport, _Component);

  return _createClass(CustomerSupport, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initForm();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var formInfo = this.props.formInfo;
      var layout = this.state.layout;

      if (prevProps.formInfo.category && formInfo.category && prevProps.formInfo.category !== formInfo.category) {
        var category = formInfo.category.value;
        layout.steps[0].formInputList[1].options = category && category !== '' ? ZendeskSubCategories[category] : [];
        this.setState({
          layout: layout
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          render = _this$props.render,
          propsCasinoIdStatus = _this$props.propsCasinoIdStatus,
          isGuest = _this$props.isGuest;
      var _this$state = this.state,
          layout = _this$state.layout,
          messageResponse = _this$state.messageResponse,
          responseSuccess = _this$state.responseSuccess;
      return render({
        layout: layout,
        submitSupportMessage: this._submitSupportMessage,
        messageResponse: messageResponse,
        responseSuccess: responseSuccess,
        propsCasinoIdStatus: propsCasinoIdStatus,
        isGuest: isGuest
      });
    }
  }]);
}(Component);

CustomerSupport.propTypes = {
  formInfo: PropTypes.isRequired,
  setFormInfo: PropTypes.isRequired,
  playerId: PropTypes.isRequired,
  casinoId: PropTypes.isRequired,
  playerName: PropTypes.isRequired,
  email: PropTypes.isRequired,
  render: PropTypes.isRequired,
  isGuest: PropTypes.isRequired
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var token = _ref2.token;
  return {
    isGuest: !!(token && token.lastLoginInfo && token.lastLoginInfo.loginMethod && token.lastLoginInfo.loginMethod === 'Guest')
  };
};

export default connect(mapStateToProps, null)(CustomerSupport);